import React, { CSSProperties } from 'react';

interface NeighborhoodProps {
  detailListStyle: CSSProperties,
  subdivisionName: string | undefined,
  associationYN: boolean | undefined,
  associationFee: number | undefined,
  zoningDescription: string | undefined,
  community: string | undefined,
}

// TODO:  add AssociationAmentities for homes with this data
//        See example property here: /#/537f17b0-4942-11ec-abaf-68f4c5fcbb7d/details

const Neighborhood = ({detailListStyle, subdivisionName, associationYN, associationFee, zoningDescription, community} : NeighborhoodProps) => {

	return (
		<React.Fragment>
			<p className="text-uppercase cc-font-weight--bold mb-1">
				<i className="fal fa-city me-2" />
        Neighborhood
			</p>
			<ul style={detailListStyle}>
				{subdivisionName && <li><span className="cc-font-weight--normal">Subdivision:</span> {subdivisionName}</li>}
				<li><span className="cc-font-weight--normal">Neighborhood Association:</span> {associationYN === true ? 'Yes' : 'No'}</li>
				{associationFee && <li><span className="cc-font-weight--normal">Association Fee:</span> {associationFee}</li>}
				{zoningDescription && <li><span className="cc-font-weight--normal">Zoning:</span> {zoningDescription}</li>}
				{community && <li><span className="cc-font-weight--normal">Community:</span> {community}</li>}
			</ul>
		</React.Fragment>
	);
};

export default Neighborhood;